
import React, { forwardRef, useCallback, useEffect, useRef, useState } from 'react';
import { View, Text, StyleSheet, Platform, Modal, TouchableOpacity, ActivityIndicator, SafeAreaView, BackHandler, Linking, ImageBackground } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { getLatestAppVersion } from '../../Redux/Actions/getAppConfig';
import WebView from 'react-native-webview';
import DeviceInfo from 'react-native-device-info';
import { ImageComp } from '../../components/Image/Image';
import { CHEVRON_LEFT, CROSS, CUSTOM_PRELOADER_IMG } from '../../assets';
import { setGoHome } from '../../Redux/Reducers/appConfigReducer';
import { getCleanUrl, isWeb, sendMessageToFrame } from '../../utils/Helper';
import { COLORS } from '../../style';
import { useCssStyle } from '../../customHook/getCssStyle';
import CustomPressable from '../../components/customPressable/customPressable';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
import { current_client_config } from '../../config/Constant';
import Loader from '../../components/Loader/loader';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useFocusEffect } from '@react-navigation/native';
import KeyboardAvoidingWrapper from '../../components/keyboardAvoidingWrapper';
import { setChatInterface } from '../../Redux/Reducers/appPreservedConfigReducer';


export const InnspireChatBot = forwardRef((props, ref) => {
    const dispatch = useDispatch();
    const getStyles = useCssStyle();

    const { isLoggedIn, loggedInRoomNumber, fcmToken } = useSelector(state => state.appConfigSlice);
    const { chatInterface } = useSelector(state => state.appPreservedConfigSlice);
    const { currentGuestDetails } = useSelector(state => state.guestDetailsSlice);

    const { isBookingFound, bookingData } = useSelector(state => state.checkInSlice.bookingStatus);

    const [loading, setLoading] = useState(true);
    const [errorInit, setErrorInit] = useState(false);


    const url = `https://guest-journey.s3.us-east-1.amazonaws.com/static/innspire_chatbot.html?V=${chatInterface.innspireCBVersion}`;


    // Handle close button click
    const handleCloseChatBot = () => {
        dispatch(setChatInterface({ showConversation: false }));
        return true;
    };

    const handleErrorInit = () => {
        dispatch(setRenderFlashMessage(true, { type: "danger", message: "Error initiating chat" }));
    }


    const sendAppConfigToWeb = async () => {

        let loginCred = null;


        const isInnSpireChatLoginInit = await AsyncStorage.getItem('innSpireChatLoginInit');
        if (isLoggedIn && !(isInnSpireChatLoginInit == "true")) {
            loginCred = {
                "first_name": currentGuestDetails?.guestProfile?.firstName,
                "last_name": currentGuestDetails?.guestProfile?.lastName,
                "reservation_id": currentGuestDetails?.reservationNumber,
                "checkin_date": currentGuestDetails?.checkInDate?.split("T")[0],
                'checkout_date': currentGuestDetails?.plannedCheckOutDate?.split("T")[0],
                "room": loggedInRoomNumber,
                "profile_id": currentGuestDetails?.guestProfile.pmsProfileId,
            }
            
            AsyncStorage.setItem("innSpireChatLoginInit", "true")
        } else if(isBookingFound && !(isInnSpireChatLoginInit == "true")) {
            loginCred = {
                "first_name":bookingData?.firstName,
                "last_name": bookingData?.lastName,
                "reservation_id": bookingData?.reservationNumber,
                "confirmation_id": bookingData?.confirmationNumber,
                "checkin_date": bookingData?.checkInDate?.split("T")[0],
                'checkout_date': bookingData?.plannedCheckOutDate?.split("T")[0],
                "profile_id": bookingData?.profileId,
            }
            
            AsyncStorage.setItem("innSpireChatLoginInit", "true")
        }

        const device_id = await DeviceInfo.getUniqueId();
        const data = {
            type: 'INNSPIRECHAT_APP_CONFIG',
            payload: {
                device_type: Platform.OS,
                device_id: device_id || null,
                device_token: fcmToken || null,
                apiUrl: chatInterface.api_url,
                innspireCBVersion: chatInterface.innspireCBVersion,
                css_config: {
                    stylesheet_url: getCleanUrl(chatInterface.innspireCBStyle)
                },
                chatApi: chatInterface.api_url,
                theme: {
                    assetBackgroundSelectorColor: COLORS.BACKGROUND_COLOR,
                    assetFontSelectorColor: COLORS.BACKGROUND_COLOR_CONTRAST,
                },
                api_key: chatInterface.webIntegrationId,
                hotel_code: current_client_config.replace("GJ_", ""),
                creds: loginCred,
            }
        };

        sendMessageToFrame(ref, data);
    };

    // Handle receiving messages from WebView or iframe
    const handleOnMessageReceive = (event) => {
        try {
            if (isWeb() && !url.includes(event.origin)) {
                return;
            }

            const message = isWeb() ? JSON.parse(event.data) : JSON.parse(event.nativeEvent.data);
            console.log("innspire_chatbot rn: ", message);

            if (message.type == 'INNSPIRECHAT_GET_CONFIG') {
                sendAppConfigToWeb();
            }

            if (message.type == 'INNSPIRECHAT_INITIALIZED') {
                setTimeout(() => {
                    setLoading(false);
                    setErrorInit(false);
                }, 2000);
            }

            if (message.type == "INNSPIRECHAT_ERROR_INITIALING") {
                setLoading(false);
                setErrorInit(true);
            }

            if(message.type == "INNSPIRECHAT_ERROR"){
                handleCloseChatBot();
                dispatch(setRenderFlashMessage(true, { type: "danger", message: "Something went wrong" }));
            }

            if (message.type == "INNSPIRECHAT_CLOSE") {
                handleCloseChatBot();
            }
        } catch (error) {
            console.log('Error in onMessage:', error);
        }
    };

    // Handle conversation visibility based on loading and showConversation state
    useEffect(() => {
        if (chatInterface.showConversation) {
            if (errorInit) {
                handleErrorInit();
                handleCloseChatBot();
                return
            }
            if (!loading) {
                setTimeout(() => {
                    sendMessageToFrame(ref, { type: "INNSPIRECHAT_SHOW" });
                }, 10);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, errorInit, chatInterface.showConversation]);



    useEffect(() => {
        if(isBookingFound) sendAppConfigToWeb();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[isBookingFound])




    useFocusEffect(
        useCallback(() => {
          let backHandler;
      
          if (chatInterface.showConversation) {
            backHandler = BackHandler.addEventListener(
              'hardwareBackPress',
              () => {return true;}
            );
          }
          return () => {
            backHandler?.remove(); // remove when unfocus or when deps change
          };
        }, [chatInterface.showConversation])
    );

    
    // Add event listener for web platform
    useEffect(() => {
        if (isWeb()) {
            window.addEventListener("message", handleOnMessageReceive);
        }

        return () => {
            if (isWeb()) {
                window.removeEventListener("message", handleOnMessageReceive);
            }
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const KeyboardWrapper = Platform.OS === 'android' ? KeyboardAvoidingWrapper : React.Fragment;


    return (
        <View style={{ ...getStyles(['customModalContainer']), display: chatInterface.showConversation ? "block" : "none" }}>
            <ImageBackground
                source={CUSTOM_PRELOADER_IMG}
                style={getStyles(['innspireChatContainer'])}
                resizeMode="cover"
                id='innspireChatContainer'
            >
            {loading && (
                <>
                    <SafeAreaView style={getStyles(['safeArea', 'crossOverContainer_Container'])}>
                        <CustomPressable style={getStyles(['crossOverContaniner_Cross'])} onPress={handleCloseChatBot}>
                            <ImageComp source={CROSS} />
                        </CustomPressable>
                    </SafeAreaView>
                    <View style={{height: "100%", justifyContent:"center", alignItems:"center"}}>
                        <Loader style={getStyles(['crossOverContaniner_loader'])} />
                    </View>
                </>
            )}
                <SafeAreaView style={getStyles(['safeArea', {flex: 1}])}>
                    {isWeb() ? (
                        <iframe
                            ref={ref}
                            src={url}
                            style={getStyles(['innspireChatContainer_iframe'])}
                            title="ChatBot"
                            allow="microphone; camera"
                        />
                    ) : (
                        <KeyboardWrapper keyboardVerticalOffset={0}>
                            <WebView
                                ref={ref}
                                style={getStyles(['innspireChatContainer_webview'])}
                                originWhitelist={['*']}
                                source={{ uri: url }}
                                onMessage={handleOnMessageReceive}
                                showsVerticalScrollIndicator={false}
                                javaScriptEnabled={true}
                                webviewDebuggingEnabled={true}
                                pullToRefreshEnabled={false}
                                cacheEnabled={true}
                                onShouldStartLoadWithRequest={(event) => {
                                    const isExternal = event.url !== url;
                                    console.log("webview external link", event);
                                    
                                    if (isExternal) {
                                        if (Platform.OS === 'ios' && event.navigationType === 'click') {
                                            Linking.openURL(event.url);
                                            return false;
                                        }
                                
                                        if (Platform.OS === 'android') {
                                            // Optional safety net for Android too
                                            Linking.openURL(event.url);
                                            return false;
                                        }
                                    }
                                
                                    return true;
                                }}
                            />
                        </KeyboardWrapper>
                    )}
                </SafeAreaView>
            </ImageBackground>
        </View>
    );
});